import React from 'react'
import styled from 'styled-components'

export type BreadcrumbProps = {
  breadcrumb: string,
}

const homeUrl = '/'

const StyledBreadcrumbContainer = styled.div`
  width: 100%;
  background: #F7F8FA;
  z-index: 1;

  @media screen and ${props => props.theme.media.sm} {
    z-index: unset;
  }
`

const StyledBreadcrumbText = styled.p`
  font-style: normal;
  font-size: 12px;
  line-height: 21px;
  color: ${props => props.theme.members.colors.gray};
  text-decoration: none;
  padding: 1rem 1.25rem;
  margin: 0 auto;
  max-width: 1120px;
  box-sizing: content-box;

  a {
    text-decoration: none;
    color: ${props => props.theme.members.colors.gray};

    &:hover {
      text-decoration: underline;
    }
  }

  @media ${props => props.theme.media.md} {
    padding: 1rem 1.5rem;
  }
`

const StyledConnector = styled.span`
  margin: 0 4px;
`

export const StyledBreadcrumb: React.FC<BreadcrumbProps> = (props: BreadcrumbProps): JSX.Element => {
  const breadcrumbs = props.breadcrumb.split(' > ')

  return (
    <StyledBreadcrumbContainer>
      <StyledBreadcrumbText>
        <a href={homeUrl}>フリーランス・副業・業務委託の求人情報ならクラウドワークステック（旧クラウドテック）</a>
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={index}>
            <StyledConnector>{'>'}</StyledConnector><span>{breadcrumb}</span>
          </React.Fragment>
        ))}
      </StyledBreadcrumbText>
    </StyledBreadcrumbContainer>
  )
}
